const List = ({ children }: { children: React.ReactNode }) => {
  return <ul className="pl-5">{children}</ul>;
};

const ListItem = ({ children }: { children: React.ReactNode }) => {
  return <li className="list-disc list-inside">{children}</li>;
};

export { List, ListItem };
